

// export const navItems = [
//   { label: "Ranks", href: "#" },
//   { label: "Hashiras", path:"/hashiras"},
//   { label: "Pricing", href: "#" },
//   { label: "Testimonials", href: "#" },
// ];

export const navItems = [
  { label: "Home", id: "hero" },
  { label: "About", id: "About" },
  { label: "Tech", id: "Techs" },
  { label: "Projects", id: "Projects" },
  { label: "Contacts", id: "Contact" },
  // { label: "About", path: "/hashira" }, 
  // { label: "Techs", path: "/demonspage" },
  // { label: "Project", path: "/muzanpage" } ,
  // { label: "Contact", path: "/ubuyashiki" } 


];
